// Draft / Published pill for the Group and Event editors and manage lists
// (2026-10-12 — groups and events publish like courses and practices).
export default function StatusPill({ draft }) {
  const style = draft
    ? { color: '#6b7280', background: '#f3f4f6', border: '1px dashed #9ca3af' }
    : { color: '#166534', background: '#dcfce7', border: '1px solid #86efac' };
  return (
    <span style={{
      fontSize: '0.6875rem', fontWeight: 700, letterSpacing: 0.4, textTransform: 'uppercase',
      borderRadius: 999, padding: '2px 9px', whiteSpace: 'nowrap', ...style,
    }}>{draft ? 'Draft' : 'Published'}</span>
  );
}
